import Vue from "vue";
import AppSN from "./AppSN.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(AppSN),
}).$mount("#app");
